import { useSelector } from 'react-redux';
import { RootState } from '../store';

export const useReduxState = <T>(sl: (state: RootState) => T): T =>
  useSelector(sl);
